import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './theme';

// Components
import TopBar from './components/TopBar';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import Benches from './pages/InnerPages.js/BenchesPage.js/Benches';
import CobbleStone from './pages/InnerPages.js/CobbleStonePage.js/CobbleStone';
import PavingStone from './pages/InnerPages.js/PavingStonePage.js/PavingStone';
import WallCladding from './pages/InnerPages.js/WallCladdingPage.js/WallCladding';
import KerbStone from './pages/InnerPages.js/KerbStonePage.js/KerbStone';
import Pergola from './pages/InnerPages.js/PergolaPage.js/Pergola';
import AboutUs from './pages/AboutUs';
import CobbleStoneLying from './pages/InnerPages.js/CobbleStoneLying/CobbleStoneLying';
import AboutUs2 from './pages/AboutUs2';
import Gallery from './pages/Gallery';
import ContactUs from './pages/ContactUs';
import CobbleStoneDetail from './pages/InnerPages.js/CobbleStonePage.js/CobbleStoneDetail';

// Main App Component
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <TopBar />
          <Header />

          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about-us-2" element={<AboutUs2 />} />
              <Route path="/benches" element={<Benches />} />
              <Route path="/cobble-stone" element={<CobbleStone />} />
              <Route path="/paving-stone" element={<PavingStone />} />
              <Route path="/wall-cladding" element={<WallCladding />} />
              <Route path="/kerb-stone" element={<KerbStone />} />
              <Route path="/pergola" element={<Pergola />} />
              <Route path="/cobble-stone-lying" element={<CobbleStoneLying />} />
              <Route path="/cobble-stone/:id" element={<CobbleStoneDetail />} />
              <Route path="/contact-us" element={<ContactUs />} />
            </Routes>
          </Box>

          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
